import actionTypes from '../constants/action-types';

const publishedDataLoaded = (state = false, action) => {
  if (action.type !== actionTypes.SET_PUBLISHED_DATA_LOADED_STATUS) return state;
  return action.payload.status;
};

export default publishedDataLoaded;
